<svg
  width="46"
  height="46"
  viewBox="0 0 46 46"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M22.8805 44.3148C34.6339 44.3148 44.1619 34.8865 44.1619 23.256C44.1619 11.6256 34.6339 2.19727 22.8805 2.19727C11.1271 2.19727 1.59912 11.6256 1.59912 23.256C1.59912 34.8865 11.1271 44.3148 22.8805 44.3148Z"
    fill="url(#paint0_linear_852_45082)"
  />
  <path
    d="M43.6619 23.256C43.6619 34.6054 34.3627 43.8148 22.8805 43.8148C11.3983 43.8148 2.09912 34.6054 2.09912 23.256C2.09912 11.9067 11.3983 2.69727 22.8805 2.69727C34.3627 2.69727 43.6619 11.9067 43.6619 23.256Z"
    stroke="#774700"
    stroke-opacity="0.5"
  />
  <path
    d="M15.7814 26.1133C17.3485 26.1133 18.6189 24.542 18.6189 22.6035C18.6189 20.6651 17.3485 19.0938 15.7814 19.0938C14.2142 19.0938 12.9438 20.6651 12.9438 22.6035C12.9438 24.542 14.2142 26.1133 15.7814 26.1133Z"
    fill="#1A1626"
  />
  <path
    d="M29.9713 26.1133C31.5384 26.1133 32.8088 24.542 32.8088 22.6035C32.8088 20.6651 31.5384 19.0938 29.9713 19.0938C28.4042 19.0938 27.1338 20.6651 27.1338 22.6035C27.1338 24.542 28.4042 26.1133 29.9713 26.1133Z"
    fill="#1A1626"
  />
  <path
    d="M17.8344 35.3497C20.4328 33.5429 25.1119 33.4235 27.9182 35.3497C28.568 35.7941 29.6448 35.4852 29.4036 34.9657C26.9506 29.6751 18.797 29.6863 16.3496 34.9657C16.1077 35.4852 17.1874 35.7976 17.8344 35.3497Z"
    fill="#1A1626"
  />
  <path
    d="M16.3237 14.0486C8.51061 12.0642 11.0119 15.7839 17.4048 18.2576C21.012 19.6538 21.4674 15.3529 16.3237 14.0486Z"
    fill="#D69600"
  />
  <path
    d="M29.431 14.061C24.288 15.366 24.7427 19.6662 28.3506 18.2693C34.7449 15.7949 37.2462 12.0752 29.431 14.061Z"
    fill="#D69600"
  />
  <defs>
    <linearGradient
      id="paint0_linear_852_45082"
      x1="22.8805"
      y1="44.3148"
      x2="22.8805"
      y2="2.19727"
      gradientUnits="userSpaceOnUse"
    >
      <stop stop-color="#FF7B00" />
      <stop offset="0.3236" stop-color="#FFAE00" />
      <stop offset="0.6205" stop-color="#FFD600" />
      <stop offset="0.8558" stop-color="#FFEE00" />
      <stop offset="1" stop-color="#FFF700" />
    </linearGradient>
  </defs>
</svg>
